import React, { Component } from "react";
import styles from "./style.module.scss";
import c from "classnames";
import Header from "components/Header";
import UnderlinedLink from "components/UnderlinedLink";
import renderFloatingTeamSvg from "components/FloatingTeamSvg";
import Footer from "components/Footer";
import Translator from "components/Translator";
// import Positions from "components/Positions";
import SEO from "components/SEO";
import Offices from "components/Offices";
import Benefits from "components/Benefits";
import Video from "components/Video";

const title = "v1_people-meta-title";
const description = "v1_people-meta-description";

class PeoplePage extends Component {
  constructor(props) {
    super(props);
    this.images = {};
  }

  componentWillMount() {
    const req = require.context("../../assets/people", false, /.*\.png$/);
    req.keys().forEach(key => {
      this.images[key.replace("./", "").replace(".png", "")] = req(key);
    });
  }

  render() {
    return (
      <Translator>
        {t => (
          <div className={styles.PeoplePage}>
            <SEO
              title={t(title)}
              description={t(description)}
              url="https://igenius.ai/people"
            />

            <Header />

            <div className="section section-header-padding">
              <div className="row">
                <div className="col-12">
                  <div className={c("row", styles.titleBlock)}>
                    <div className="col-12 margin-bottom-32">
                      <h1 className="font-tt3">{t("v1_people-title-1")}</h1>
                    </div>
                    <div className="col-12 col-sm-7 margin-bottom-48">
                      <div className="font-body font-color-grey">
                        {t("v1_people-subtitle-1")}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-sm-4 offset-sm-8 margin-bottom-24">
                      <h2 className="font-tt4">{t("v1_people-title-2")}</h2>
                    </div>
                    <div className="col-12 col-sm-4 offset-sm-8 font-body  font-color-grey margin-bottom-32">
                      {t("v1_people-subtitle-2")}
                    </div>
                    <div className="col-12 col-sm-4 offset-sm-8 font-body">
                      <UnderlinedLink
                        externalLink
                        path="https://www.linkedin.com/company/igeniusai/jobs"
                        label={t("v1_people-cta-2")}
                        labelKey="v1_people-cta-2"
                        active
                        greenLine
                        liftAnimation
                      />
                    </div>
                  </div>
                </div>

                <svg
                  className={c(styles.regolo, "rotatingSvg")}
                  width="49px"
                  height="501px"
                  viewBox="0 0 49 501"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <g
                    id="g-1"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect
                      id="wash-1"
                      fill="#FA8368"
                      x="0.0576587303"
                      y="0.131638636"
                      width="48"
                      height="500"
                    />
                  </g>
                </svg>
                <svg
                  className={c(styles.semiCircle, "rotatingSvg")}
                  width="173px"
                  height="345px"
                  viewBox="0 0 173 345"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <defs>
                    <linearGradient
                      x1="50%"
                      y1="0%"
                      x2="50%"
                      y2="100%"
                      id="linearGradient-1"
                    >
                      <stop stopColor="#BAF8E9" offset="0%" />
                      <stop stopColor="#84EFCF" offset="100%" />
                    </linearGradient>
                  </defs>
                  <g
                    id="g-2"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <path
                      d="M172.63605,0.0404428438 C77.6451695,0.0404428438 0.63984611,77.0457662 0.63984611,172.036647 C0.63984611,267.027527 77.6451695,344.03285 172.63605,344.03285 L172.63605,0.0404428438 Z"
                      id="wash-2"
                      fill="url(#linearGradient-1)"
                    />
                  </g>
                </svg>
              </div>
            </div>

            <div className={styles.cultureSection}>
              <div className="row align-items-center">
                <div className="col-12 col-sm-5 margin-bottom-48">
                  <h2 className="font-tt3 margin-bottom-32">
                    {t("v1_people-title-3")}
                  </h2>
                  <span className="font-body font-color-grey">
                    {t("v1_people-subtitle-3")}
                  </span>
                </div>
                <div className="col offset-sm-1">
                  <Video
                    poster={this.images["cozzolino"]}
                    videoId="31Z9YAsBzhA"
                  />
                </div>
              </div>
            </div>

            <div className="section">
              <div className="row">
                <div className="col-12 margin-bottom-80">
                  <h2 className="font-tt3">{t("v1_people-title-4")}</h2>
                </div>
                <div className="col-12 col-sm-7">
                  <div className="row bottom-spacing-56">
                    <div className="col-12 col-sm-5 d-flex flex-column align-items-start">
                      <h2 className="font-tt5 margin-bottom-24">
                        {t("v1_people-subtitle-4a")}
                      </h2>
                      <span className="font-mini-spacemono font-color-grey margin-bottom-48">
                        {t("v1_people-text-4a")}
                      </span>
                    </div>

                    <div className="col-12 col-sm-5 offset-sm-1 d-flex flex-column align-items-start">
                      <h2 className="font-tt5 margin-bottom-24">
                        {t("v1_people-subtitle-4b")}
                      </h2>
                      <span className="font-mini-spacemono font-color-grey margin-bottom-48">
                        {t("v1_people-text-4b")}
                      </span>
                    </div>

                    <div className="col-12 col-sm-5 d-flex flex-column align-items-start">
                      <h2 className="font-tt5 margin-bottom-24">
                        {t("v1_people-subtitle-4c")}
                      </h2>
                      <span className="font-mini-spacemono font-color-grey margin-bottom-48">
                        {t("v1_people-text-4c")}
                      </span>
                    </div>

                    <div className="col-12 col-sm-5 offset-sm-1 d-flex flex-column align-items-start">
                      <h2 className="font-tt5 margin-bottom-24">
                        {t("v1_people-subtitle-4d")}
                      </h2>
                      <span className="font-mini-spacemono font-color-grey margin-bottom-48">
                        {t("v1_people-text-4d")}
                      </span>
                    </div>
                  </div>
                </div>

                <svg
                  className={c(styles.greenSemiCircle, "rotatingSvg")}
                  width="173px"
                  height="345px"
                  viewBox="0 0 173 345"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <defs>
                    <linearGradient
                      x1="50%"
                      y1="0%"
                      x2="50%"
                      y2="100%"
                      id="semiCircleGradient"
                    >
                      <stop stopColor="#00e274" offset="0%" />
                      <stop stopColor="#00c140" offset="100%" />
                    </linearGradient>
                  </defs>
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <path
                      d="M172.63605,0.0404428438 C77.6451695,0.0404428438 0.63984611,77.0457662 0.63984611,172.036647 C0.63984611,267.027527 77.6451695,344.03285 172.63605,344.03285 L172.63605,0.0404428438 Z"
                      fill="url(#semiCircleGradient)"
                    />
                  </g>
                </svg>
                <svg
                  className={styles.blueCircle}
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="108"
                  height="108"
                  viewBox="0 0 108 108"
                >
                  <circle
                    fill="#45A2E5"
                    fillRule="evenodd"
                    transform="translate(-1224 -1997)"
                    cx="1278"
                    cy="2051"
                    r="54"
                  />
                </svg>
              </div>
            </div>

            <Benefits />

            <div className={styles.teamSection}>
              <div className="row justify-content-center">
                <div className="col-12 d-flex align-items-center">
                  <div className="col-12 col-sm-5 d-flex flex-column justify-content-center align-items-start">
                    <h2 className="font-tt3 margin-bottom-48">
                      {t("v1_people-title-6")}
                    </h2>
                    <span className="font-body font-color-grey margin-bottom-48">
                      {t("v1_people-subtitle-6")}
                    </span>
                  </div>
                  <div className="col-12 col-sm-7">
                    {renderFloatingTeamSvg()}
                  </div>
                </div>
              </div>
            </div>

            <div
              className={c(
                "container-fluid",
                "margin-bottom-48",
                styles.teamImgs
              )}
            >
              <div className="row align-items-center">
                <div className="col-11 offset-1 col-sm-4 offset-sm-0">
                  <img
                    className=""
                    src={this.images["backend-team"]}
                    alt="igenius-team-backend"
                  />
                </div>
                <div className="col-9 col-sm-4 offset-sm-0">
                  <img
                    className=""
                    src={this.images["frontend-team"]}
                    alt="igenius-team-frontend"
                  />
                </div>
                <div className="col-10 offset-1 col-sm-4 offset-sm-0">
                  <img
                    className=""
                    src={this.images["product-team"]}
                    alt="igenius-team-product"
                  />
                </div>
              </div>
            </div>

            <Offices />

            {/* <Positions /> */}

            <Footer />
          </div>
        )}
      </Translator>
    );
  }
}

PeoplePage.propTypes = {};

export default PeoplePage;



// WEBPACK FOOTER //
// ./src/pages/people/index.js